global.SYSTEM = !!!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'ios' : 'android'
global.INAPP =  navigator.userAgent.toLowerCase().match(/wuba/i) == 'wuba' ? true : false
global.INWEIXIN = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' ? true : false
global.CONTEXT = INAPP ? 'app' : INWEIXIN ? 'weixin' : 'm'
